export * from './reset-password/reset-password.component';
export * from './register/register.component';
export * from './login/login.component';
export * from './header/header.component';
export * from './forgot-password/forgot-password.component';
export * from './footer/footer.component';
export * from './verify-email/verify-email.component';
export * from './home/home.component';